import { Breadcrumb, BreadcrumbItem, Container } from "reactstrap";
import useToggle from "../../../hooks/useToggle";

import SupportalInviteUserDrawer from "../../../components/Drawers/SupportalInviteUserDrawer/SupportalInviteUserDrawer";
import AppHelmet from "../../../components/AppComponents/AppHelmet";
import TableUsersView from "../TableUsersView";
import AppPageHeader from "../../../components/Headers/AppPageHeader";
import { Link } from "react-router-dom";

const SupportalUsersHeader = ({ urlStart }: { urlStart: string }) => {
  const [openDrawer, toggleDrawer] = useToggle(false);

  return (
    <div className="header">
      <Container fluid>
        <AppPageHeader
          title="Users"
          description="Manage user access and activity"
          actionButtonName="New"
          actionButtonColor="primary"
          action={toggleDrawer}
          breadcrumbs={
            <Breadcrumb
              className="tw:pt-2"
              listClassName="tw:p-0 tw:m-0 tw:bg-transparent"
            >
              <BreadcrumbItem>
                <Link to={urlStart}>
                  <i className="mdi mdi-lifebuoy" />
                </Link>
              </BreadcrumbItem>
              <BreadcrumbItem>Users</BreadcrumbItem>
            </Breadcrumb>
          }
        />
      </Container>
      <SupportalInviteUserDrawer open={openDrawer} onClose={toggleDrawer} />
    </div>
  );
};

// A table of all the users in this GrowthCloud instance.
const SupportalUsers = ({ urlStart }: { urlStart?: string }) => {
  urlStart = urlStart || "/supportal";

  return (
    <>
      <AppHelmet title="All Users - GrowthCloud.com" />
      <SupportalUsersHeader urlStart={urlStart} />
      <TableUsersView urlStart={urlStart} />
    </>
  );
};

export default SupportalUsers;
